export default "__VITE_ASSET__DqThdMxD__"